import { Component, OnInit, HostListener } from "@angular/core";

@Component({
  selector: "app-ui",
  templateUrl: "./ui.component.html",
})
export class UiComponent implements OnInit {
  public innerWidth: any;
  public hiddenMenu = false;
  public constructor() {
    this.innerWidth = window.innerWidth;
  }

  getImage() {
    return `assets/images/cubo.png`;
  }

  public ngOnInit(): void {}

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  redirect() {
    window.open("http://www.cuboit.com.ar", "_blank");
  }

  public hideMenu(hide){
    this.hiddenMenu = hide;
  }
}
